import React, { useState } from 'react';
import { message } from 'antd';
import {
  GiftIcon,
  DocumentDuplicateIcon,
  CheckIcon,
  ChatBubbleLeftRightIcon,
  EnvelopeIcon,
  ShareIcon,
} from '@heroicons/react/24/outline';
import { formatCurrency } from '../../../utils/baseUtils';

// Koyu hero zemini üzerinde tutarlı stil için paylaşım butonu sınıfı.
const shareBtnCls =
  'inline-flex h-9 items-center gap-1.5 rounded-lg bg-white/15 px-3 text-sm font-semibold text-white ring-1 ring-white/20 transition hover:bg-white/25';

const ReferralHero = ({ data, onShare }) => {
  const [copied, setCopied] = useState(false);
  const link = data?.referrallink || '';
  const code = data?.referralcode || '';
  const shareText = link || code;

  const handleCopy = async () => {
    if (!shareText) return;
    try {
      if (!navigator.clipboard?.writeText) throw new Error('no clipboard');
      await navigator.clipboard.writeText(shareText);
      setCopied(true);
      message.success('Link copied');
      setTimeout(() => setCopied(false), 2000);
    } catch {
      message.info('Copy the referral link manually');
    }
  };

  const canNativeShare =
    typeof navigator !== 'undefined' && typeof navigator.share === 'function';

  const handleNativeShare = async () => {
    try {
      await navigator.share({
        title: 'Join me on Thisway',
        text: `Join Thisway and get ${formatCurrency(
          data?.rewardamount || 0,
        )} in credits.`,
        url: link,
      });
    } catch {
      // Kullanıcı paylaşım sayfasını kapattı — işlem gerekmez.
    }
  };

  return (
    <section className="reveal overflow-hidden rounded-xl bg-gradient-to-r from-blue-700 to-blue-500 p-6 text-white shadow-sm dark:from-sky-700 dark:to-sky-500 sm:p-8">
      <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-white/80">
        <GiftIcon className="h-5 w-5" />
        Refer &amp; Earn
      </div>
      <h2 className="mt-2 text-2xl font-bold sm:text-3xl">
        Earn {formatCurrency(data?.rewardamount || 0, { maximumFractionDigits: 0 })}{' '}
        per referral
      </h2>
      <p className="mt-1 max-w-xl text-sm text-white/80">
        Both restaurants get credit once the new restaurant completes{' '}
        {data?.minimumorders ?? 0} paid orders. Credit is valid for{' '}
        {data?.expirationdays ?? 0} days.
      </p>

      <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center">
        <div className="flex min-w-0 flex-1 items-center rounded-lg bg-white/15 px-3 py-2 ring-1 ring-white/20">
          <span className="truncate text-sm font-medium">
            {shareText || 'No referral link available'}
          </span>
        </div>
        <button
          type="button"
          onClick={handleCopy}
          disabled={!shareText}
          className="inline-flex h-10 shrink-0 items-center justify-center gap-1.5 rounded-lg bg-white px-4 text-sm font-semibold text-blue-700 transition hover:bg-blue-50 disabled:opacity-50"
        >
          {copied ? (
            <CheckIcon className="h-4 w-4" />
          ) : (
            <DocumentDuplicateIcon className="h-4 w-4" />
          )}
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>

      <div className="mt-4 flex flex-wrap gap-2">
        <button
          type="button"
          className={shareBtnCls}
          onClick={() => onShare('sms')}
        >
          <ChatBubbleLeftRightIcon className="h-4 w-4" />
          SMS
        </button>
        <button
          type="button"
          className={shareBtnCls}
          onClick={() => onShare('email')}
        >
          <EnvelopeIcon className="h-4 w-4" />
          Email
        </button>
        {canNativeShare ? (
          <button
            type="button"
            className={shareBtnCls}
            onClick={handleNativeShare}
          >
            <ShareIcon className="h-4 w-4" />
            Share
          </button>
        ) : null}
      </div>
    </section>
  );
};

export default ReferralHero;
